module.exports = __webpack_public_path__ + "static/media/4.c9ae0eb1.jpeg";